import {
  createAsyncThunk,
  createSlice,
  isRejectedWithValue,
} from "@reduxjs/toolkit";
import axios from "axios";
import { UsersIcon } from "lucide-react";

export const registerUser = createAsyncThunk(
  "user/register",
  async (userData, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${process.env.BACKEND_URL}/api/register/user`,
        userData,
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );
      return res.data;
    } catch (error) {
      console.error("API Error:", error);
      return rejectWithValue(
        error.response?.data || "Etwas ist schiefgelaufen"
      );
    }
  }
);

export const updateContact = createAsyncThunk(
  "user/updateContact",
  async (userData, { rejectWithValue }) => {
    try {
      const res = await axios.put(
        `${process.env.BACKEND_URL}/user/${userData.id}/contact`,
        userData,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );
      console.log(
        "Gesendet an:",
        `${process.env.BACKEND_URL}/user/${userData.id}/contact`
      );
      return res.data;
    } catch (error) {
      console.error(
        "API Error:",
        error.response?.data || error.message || error
      );
      return rejectWithValue(
        error.response?.data || "Etwas ist schiefgelaufen"
      );
    }
  }
);

export const updateAdress = createAsyncThunk(
  "user/updateAdress",
  async (userData, { rejectWithValue }) => {
    try {
      const res = await axios.put(
        `${process.env.BACKEND_URL}/user/${userData.id}/address`,
        userData,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );
      return res.data;
    } catch (error) {
      console.error("API Error:", error);
      return rejectWithValue(
        error.response?.data || "Etwas ist schiefgelaufen"
      );
    }
  }
);

export const updatePassword = createAsyncThunk(
  "user/updatePassword",
  async (userData, { rejectWithValue }) => {
    try {
      const res = await axios.put(
        `${process.env.BACKEND_URL}/user/${userData.id}/password`,
        userData,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );
      return res.data;
    } catch (error) {
      console.error("API Error:", error);
      return rejectWithValue(
        error.response?.data || "Etwas ist schiefgelaufen"
      );
    }
  }
);

export const updateEmail = createAsyncThunk(
  "user/updateEmail",
  async (userData, { rejectWithValue }) => {
    try {
      const res = await axios.put(
        `${process.env.BACKEND_URL}/${userData.id}/email`,
        userData,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );
      return res.data;
    } catch (err) {
      console.error("API Error:", err);
      return rejectWithValue(err.response?.data || "Etwas ist schiefgelaufen");
    }
  }
);

export const sendSms = createAsyncThunk(
  "user/sendSms",
  async (userData, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${process.env.BACKEND_URL}/api/send-sms-code`,
        userData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return res.data;
    } catch (err) {
      console.error("API error", err);
      return rejectWithValue(err.response?.data || "Etwas ist schiefgelaufen");
    }
  }
);

export const verifySms = createAsyncThunk(
  "user/verifySms",
  async (userData, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${process.env.BACKEND_URL}/api/verify-sms-code`,
        userData,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return res.data;
    } catch (err) {
      console.error("API error", err);
      return rejectWithValue(err.response?.data || "Etwas ist schiefgelaufen");
    }
  }
);

export const fetchUserById = createAsyncThunk(
  "user/fetchUserById",
  async (id, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${process.env.BACKEND_URL}/user/${id}`);
      return res.data.user;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Fehler beim Laden");
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState: {
    currentUser: null,
    status: null,
    error: null,
  },
  reducers: {
    setUser: (state, action) => {
      state.currentUser = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerUser.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.status = "success";
        state.currentUser = action.payload;
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(sendSms.pending, (state) => {
        state.smsStatus = "loading";
      })
      .addCase(sendSms.fulfilled, (state, action) => {
        state.smsStatus = "success";
        state.smsMessage = action.payload.message;
      })
      .addCase(sendSms.rejected, (state, action) => {
        state.smsStatus = "error";
        state.smsError = action.payload;
      })
      .addCase(verifySms.pending, (state) => {
        state.verifyStatus = "loading";
      })
      .addCase(verifySms.fulfilled, (state) => {
        state.verifyStatus = "success";
        if (state.user) {
          state.user.isVerifiedPhone = true;
        }
      })
      .addCase(verifySms.rejected, (state, action) => {
        state.verifyStatus = "error";
        state.verifyError = action.payload;
      });
  },
});

export default userSlice.reducer;
export const { setUser } = userSlice.actions;
